<template>
  <nav class="mb-5">
    <v-app-bar elevation="0" color="white">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="grey--text"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text">
        <span class="font-weight-light">My Account</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- different website icons open menu -->
      <v-menu transition="slide-x-transition" bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0 ma-0" v-for="(item, i) in menuIcons" :key="i">
          <v-list-item class="hover-effect ma-0 pa-0">
            <a
              class="text-center grey--text text--darken-3"
              :href="item.url"
              target="_blank"
            >
              <v-img max-width="90px" :src="item.img"></v-img>
              <p>
                {{ item.name }}
              </p>
            </a>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn @click.prevent="logOut()" outlined rounded>
        <span>Sign Out</span>
        <v-icon right>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer absolute temporary v-model="drawer" width="280">
      <v-list>
        <v-list-item
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-action>
            <v-icon class="grey--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="grey--text">{{
              link.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import cfg from "@/cfg";
import { mapState } from "vuex";

export default {
  data() {
    return {
      cfg: cfg,
      drawer: false,
      links: [
        { icon: "mdi-view-dashboard", text: "Dashboard", route: "/account" },
        {
          icon: "mdi-account-circle",
          text: "Personal Info",
          route: "/profile",
        },
        { icon: "mdi-map-marker", text: "Your Addresses", route: "/addresses" },
        {
          icon: "mdi-credit-card-outline",
          text: "Payments & subscriptions",
          route: "/payments-and-subscriptions",
        },
      ],
      menuIcons: [
        {
          name: "Auctions",
          img: require("../assets/PjiliAuctions.svg"),
          url: cfg.AUCTIONS_UI_URL,
        },
        {
          name: "Pjili plus",
          img: require("../assets/PjiliPlus.svg"),
          url: cfg.PJILI_PLUS_UI_URL,
        },
      ],
    };
  },
  computed: mapState(["continueHref"]),
  methods: {
    logOut() {
      this.$store
        .dispatch("Logout")
        .then(() => {
          this.$store.dispatch("ResetState");
          if (this.continueHref) {
            window.location.href = this.continueHref
          } else {
            this.$store.dispatch("addNotification", {
              type: "success",
              message: "You have been successfully logged out, See you soon!",
            });
            this.$router.push({ name: "login" });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
  },
};
</script>
<style lang="scss">
.hover-effect {
  background-color: #fff !important;
  transition: all 0.3s;
}
.hover-effect:hover {
  background-color: #eee !important;
  transition: all 0.3s;
}
</style>
